import { Button } from '@/shared/components/ui/button';
import { cn } from '@/shared/utils/styling';
import GripIcon from '@/shared/assets/grip-icon.svg?react';
import CloseIcon from '@/shared/assets/close-icon.svg?react';

type Props = {
  isMenuOpen: boolean;
  onClick: () => void;
  className?: string;
};

const AuthorizedLayoutMenuButton = ({
  onClick,
  isMenuOpen,
  className,
}: Props) => {
  return (
    <Button
      variant="outline"
      size="icon"
      className={cn(
        'border-none rounded-full h-[4.2rem] w-[4.2rem] shadow-none',
        className
      )}
      onClick={onClick}>
      {isMenuOpen ? (
        <CloseIcon className="size-[2.4rem] text-primary" />
      ) : (
        <GripIcon className="size-[2.4rem] text-primary" />
      )}
    </Button>
  );
};

export { AuthorizedLayoutMenuButton };
